// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsInt, IsNotEmpty, IsOptional, IsBoolean, IsString, ValidateNested, Min, Max } from 'class-validator';

export class LayerForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class SymbolForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class LineweightForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  weight: number;
}

export class ColorBookForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class PlotStyleForm {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

export class AutodeskLayerForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  description: string | null;

  @IsNotEmpty()
  @IsString()
  color: string;

  @IsBoolean()
  isPlot: boolean;

  @IsBoolean()
  isNewViewportFreeze: boolean;

  @IsInt()
  @Min(0)
  @Max(90)
  transparency: number;

  @ValidateNested()
  layer: LayerForm;

  @ValidateNested()
  symbol: SymbolForm;

  @ValidateNested()
  lineweight: LineweightForm;

  @ValidateNested()
  colorBook: ColorBookForm;

  @ValidateNested()
  template: TemplateForm;

  @IsOptional()
  @ValidateNested()
  plotStyle: PlotStyleForm | null;
}

export class ParcelStyleForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class FeatureClassForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class ConfigurationForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class ParcelForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  query: string;

  @IsInt()
  priority: number;

  @IsOptional()
  @IsString()
  site?: string;

  @IsOptional()
  @IsString()
  propertyMappings?: string;

  @ValidateNested()
  featureClass: FeatureClassForm;

  @IsOptional()
  @ValidateNested()
  parcelStyle?: ParcelStyleForm;

  @IsOptional()
  @ValidateNested()
  autodeskLayer?: AutodeskLayerForm;

  @ValidateNested()
  configuration: ConfigurationForm;
}
